import { render, staticRenderFns } from "./OrderRecord.vue?vue&type=template&id=65401c4b&scoped=true"
import script from "./OrderRecord.vue?vue&type=script&lang=js"
export * from "./OrderRecord.vue?vue&type=script&lang=js"
import style0 from "./OrderRecord.vue?vue&type=style&index=0&id=65401c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65401c4b",
  null
  
)

export default component.exports